module.exports = __webpack_public_path__ + "static/media/servico_final.d3edb5a0.jpg";